import axios from "axios";

const OPENAI_API_URL = "https://api.openai.com/v1/chat/completions";
const UNSPLASH_API_URL = "https://api.unsplash.com/search/photos";

const extractJSON = (text) => {
  try {
    // Buscar el contenido entre llaves
    const match = text.match(/\{[\s\S]*\}/);
    if (!match) return null;

    // Parsear el JSON encontrado
    return JSON.parse(match[0]);
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null;
  }
};

const getImageFromUnsplash = async (query) => {
  try {
    const response = await axios.get(UNSPLASH_API_URL, {
      params: {
        query,
        per_page: 1,
        orientation: 'landscape'
      },
      headers: {
        Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_ACCESS_KEY}`
      }
    });

    if (response.data.results && response.data.results.length > 0) {
      return response.data.results[0].urls.regular;
    }
    throw new Error('No se encontraron imágenes');
  } catch (error) {
    console.error('Error getting image from Unsplash:', error);
    throw error;
  }
};

export const aiService = {
  generateDream: async (prompt) => {
    try {
      const systemPrompt = `Actúa como un asistente que ayuda a visualizar sueños y metas en un vision board basandote en la ley de la atracción. 
      Debe estar en tiempo presente como si ya se hubiera cumplido. Trata de que el sueño sea lo más realista posible.
      Genera una respuesta en formato JSON parseado con los siguientes campos:
      - title: Un título inspirador para el sueño (en español)
      - description: Una descripción motivadora (en español)
      - searchTerm: Un término de búsqueda EN INGLÉS (2-3 palabras máximo) para encontrar una imagen relacionada
      La respuesta debe ser en español (excepto searchTerm) y estar relacionada con: ${prompt}`;

      const response = await axios.post(
        OPENAI_API_URL,
        {
          model: "gpt-4o",
          messages: [
            { role: "system", content: systemPrompt },
            { role: "user", content: prompt },
          ],
          temperature: 0.7,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
            "Content-Type": "application/json",
          },
        }
      );

      const content = response.data.choices[0].message.content;
      const jsonData = extractJSON(content);
      
      if (!jsonData || !jsonData.searchTerm) {
        throw new Error("Respuesta de IA incompleta");
      }

      // Obtener imagen de Unsplash usando el término de búsqueda
      const imgSrc = await getImageFromUnsplash(jsonData.searchTerm);

      return {
        title: jsonData.title,
        description: jsonData.description,
        imgSrc
      };
    } catch (error) {
      console.error("Error generating dream:", error);
      throw new Error(
        "No se pudo generar el sueño. Por favor, intenta de nuevo."
      );
    }
  },
};
